jQuery( function( $ ) {
	// list of cookies that are white listed.
	const cookiesToKeepGermany = [
		'TawkConnectionTime',
		'__cf_bm',
		'cmplz_banner-status',
		'cmplz_consented_services',
		'cmplz_functional',
		'cmplz_marketing',
		'cmplz_policy_id',
		'cmplz_preferences',
		'cmplz_statistics',
		'datadome',
		'incap_ses_', // If contains this string keep
		'nlbi_', // If contains this string keep
		'tk_ai',
		'twk_idm_key',
		'twk_uuid_', // If contains this string keep
		'visid_incap_', // If contains this string keep
		'wordpress_logged_in_', // If contains this string keep
		'wordpress_sec_', // If contains this string keep
		'wordpress_test_cookie', // If contains this string keep
		'wp-settings-', // If contains this string keep
		'wp-settings-time-', // If contains this string keep
	];

	// Reload page on accepted cookies
	$( 'body' ).on( 'click', '.cmplz-btn.cmplz-accept', function() {
		window.location.reload();
	} );
	$( 'body' ).on( 'click', '.cmplz-btn.cmplz-deny', function() {
		window.location.reload();
	} );

	/*
	 * getCookiesToDelete
	 *
	 * Filter out what cookies to delete by checking with the white list of cookies.
	 *
	 * @returns array
	 */
	function getCookiesToDelete( keepingCookies ) {
		const currentStoredCookies = getCookies();
		// Remove all with exact match
		const cookiesToDelete = currentStoredCookies.filter( oneCookie => ! keepingCookies.includes( oneCookie ) );

		// Loop thru the list again to do a partial match search.
		cookiesToDelete.forEach( cookie => {
			keepingCookies.forEach( cookieKeep => {
				if ( cookie.startsWith( cookieKeep ) ) {
					const index = cookiesToDelete.indexOf( cookie );
					// Remove the cookie that we want to keep from the delete list
					cookiesToDelete.splice( index, 1 );
				}
			} );
		} );

		return cookiesToDelete;
	}

	/*
	 * clearCookies
	 *
	 * Set cookies from the given array to expired
	 *
	 */
	function clearCookies( cookiesArray ) {
		cookiesArray.forEach( singleCookie => {
			if ( 'undefined' !== typeof ( getCookie( singleCookie ) ) ) {
				// First removing without domain
				document.cookie = singleCookie + '=; max-age=0; expires=0;path=/;';

				// Removing with domain with currrent host
				document.cookie = singleCookie + '=; max-age=0; expires=0;path=/;domain=' + window.location.host;
				// Sometimes the cookie domain is the domain with a `.` in front of it
				document.cookie = singleCookie + '=; max-age=0; expires=0;path=/;domain=.' + window.location.host;

				// For some reason you get cookies from the .net domain too to be safe we remove these too.
				document.cookie = singleCookie + '=; max-age=0; expires=0;path=/;domain=mercuri.net';
				document.cookie = singleCookie + '=; max-age=0; expires=0;path=/;domain=.mercuri.net';

				// For subdomain
				const hostsArray = window.location.host.split( '.' );
				if ( hostsArray > 2 ) {
					document.cookie = singleCookie + '=; max-age=0; expires=0;path=/;domain=.' + hostsArray[ hostsArray.length - 2 ] + hostsArray[ hostsArray.length - 1 ];
				}

				// Special case for synotio domains to make it work on test env.
				if ( window.location.host.includes( 'synot.io' ) ) {
					document.cookie = singleCookie + '=; max-age=0; expires=0;path=/;domain=.synot.io';
				}
			}
		} );
	}

	/*
	 * getCookie
	 *
	 * Get a single cookie with specified name if no cookie is found it returns `undefined`
	 *
	 * @returns string
	 */
	function getCookie( cName ) {
		const name = cName + '=';
		const cDecoded = decodeURIComponent( document.cookie );
		const cArr = cDecoded.split( '; ' );
		let result;
		cArr.forEach( val => {
			if ( val.indexOf( name ) === 0 ) {
				result = val.substring( name.length );
			}
		} );
		return result;
	}

	/*
	 * getCookies
	 *
	 * Get all the cookies and return a array with them.
	 *
	 * @returns array
	 */
	function getCookies() {
		const cookie = document.cookie;
		const cookies = cookie.split( ';' );
		const cookiesArray = [];

		for ( let i = 1; i <= cookies.length; i++ ) {
			if ( -1 !== cookies[ i - 1 ].indexOf( '=' ) ) {
				// Remove unwanted extra cookie info after the `=` sign
				cookiesArray.push( cookies[ i - 1 ].substring( 0, cookies[ i - 1 ].indexOf( '=' ) ).trim() );
			} else {
				cookiesArray.push( cookies[ i - 1 ].trim() );
			}
		}

		return cookiesArray;
	}

	// If the site is DE and the visitor has declined marketing if somehow the cookies are there we will remove them on text page load.
	// Cookie is added when visiting a page with the microsoft form loaded.
	$( document ).ready( function() {
		if ( 'de-DE' === $( 'html' ).attr( 'lang' ) ) {
			// Check with the cookie complz what choices the user has made
			if ( 'deny' === getCookie( 'cmplz_marketing' ) || 'deny' === getCookie( 'cmplz_statistics' ) ) {
				if ( 'undefined' !== typeof ( getCookie( 'msd365mkttr' ) ) ) {
					document.cookie = 'msd365mkttr= ;max-age=0; expires=0;path=/;domain=mercuri.net';
					document.cookie = 'msd365mkttr= ;max-age=0; expires=0;path=/;domain=.mercuri.net';
					document.cookie = 'msd365mkttr= ;max-age=0; expires=0;path=/;domain=mercuri.de';
					document.cookie = 'msd365mkttr= ;max-age=0; expires=0;path=/;domain=.mercuri.de';
					document.cookie = 'msd365mkttr= ;max-age=0; expires=0;path=/;';
				}
				if ( 'undefined' !== typeof ( getCookie( 'msd365mkttrs' ) ) ) {
					document.cookie = 'msd365mkttrs= ;max-age=0; expires=0;path=/;domain=mercuri.net';
					document.cookie = 'msd365mkttrs= ;max-age=0; expires=0;path=/;domain=.mercuri.net';
					document.cookie = 'msd365mkttrs= ;max-age=0; expires=0;path=/;domain=mercuri.de';
					document.cookie = 'msd365mkttrs= ;max-age=0; expires=0;path=/;domain=.mercuri.de';
					document.cookie = 'msd365mkttrs= ;max-age=0; expires=0;path=/;';
				}
				// Clear the cookies that are not white listed if the complianz settings is deny for either marketing or statistics cookies.
				const cookieList = getCookiesToDelete( cookiesToKeepGermany );
				clearCookies( cookieList );
			}
		}
	} );
} );
